/**
 * The attributes a caller puts on a component that the component must honour.
 *
 * Most components take a props bag and can spread the whole of it. A few -
 * `Icon`, whose props are a discriminated union, `Spinner`, which takes none -
 * cannot, and those are exactly the ones that silently swallowed a caller's
 * `data-` hook (P-24).
 *
 * So they pick these out instead. `data-` and `aria-` only: a component that
 * forwarded arbitrary unknown props would pass `decorative` straight into an
 * SVG and produce a React warning on every render.
 */
export function passthrough(props: Record<string, unknown>): Record<string, unknown> {
  const out: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(props)) {
    if (key.startsWith('data-') || key.startsWith('aria-')) out[key] = value;
  }
  return out;
}
